import { render, staticRenderFns } from "./execl.vue?vue&type=template&id=35537e90&scoped=true"
import script from "./execl.vue?vue&type=script&lang=js"
export * from "./execl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35537e90",
  null
  
)

export default component.exports